import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";

import { IBoardHistoryAppointmentDock } from "../../../../../../../../../models/masterAppointment/IAppointmentBoard";
import { useAppDispatch } from "../../../../../../../../../redux/hooks";
import { setShowPopUpAppointmentDock } from "../../../../../../../../../redux/reducers/masterAppointment/appointmentBoard/appointmentDock/form";
import { ButtonPrimaryInverseWithBorder } from "../../../../../../../../common/buttons/buttons";
import { TitleH5 } from "../../../../../../../../common/titles/titles";
import { MasterAppointmentDockFormStyle } from "./containerStyle.jss";
import { MasterBoardHistoryAppointmentDockControllerForm } from "./controller/controller";
import { MasterBoardHistoryAppointmentDockList } from "./list/list";
import { ColorType } from "../../../../../../../../../common/enum/ColorType";
import { PopUpCodes } from "../../../../../../../../../common/enum/PopUpCodes";

interface IMasterAppointmentDockControllerProps {
    list: IBoardHistoryAppointmentDock[];
}

export const AppointmentDockController: React.FC<IMasterAppointmentDockControllerProps> = ({ list }) => {
    const { t } = useTranslation("common", { keyPrefix: "MASTER_APPOINTMENT.APPOINTMENT_BOARD.TITLES" });
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const style = MasterAppointmentDockFormStyle({ theme });
    
    return (
        <div className={style.container}>
            <div className={style.header}>
                <TitleH5
                    title={t("APPOINTMENTS")}
                    bold={true}
                    color={ColorType.primary}
                />
                <ButtonPrimaryInverseWithBorder
                    handleClick={() => {
                        dispatch(setShowPopUpAppointmentDock(PopUpCodes.CREATE));
                    }}
                    title={`+ ${t("ADD")}`}
                />
            </div>

            <MasterBoardHistoryAppointmentDockList list={list} />
            <MasterBoardHistoryAppointmentDockControllerForm />
        </div>
    );
};
